import { render, staticRenderFns } from "./BrbDateTimePickerNew.vue?vue&type=template&id=c441217a&"
import script from "./BrbDateTimePickerNew.vue?vue&type=script&lang=js&"
export * from "./BrbDateTimePickerNew.vue?vue&type=script&lang=js&"
import style0 from "./BrbDateTimePickerNew.vue?vue&type=style&index=0&id=c441217a&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/matin/baarbaanet/frontend/admin-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c441217a')) {
      api.createRecord('c441217a', component.options)
    } else {
      api.reload('c441217a', component.options)
    }
    module.hot.accept("./BrbDateTimePickerNew.vue?vue&type=template&id=c441217a&", function () {
      api.rerender('c441217a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/brb-components/BrbDateTimePickerNew.vue"
export default component.exports